import { makeStyles } from 'tss-react/mui';

import Typography from '../Typography';

const useStyles = makeStyles()(
  ({ breakpoints, palette, spacing }, _params, classes: any) => ({
    text: {
      textAlign: 'center',
      [`&.${classes.default}`]: { color: palette.text.default },
      [`&.${classes.contrast}`]: { color: palette.text.contrast },
      margin: spacing(0, 1, 4),
      [breakpoints.up('sm')]: {
        margin: spacing(0, 2, 6),
      },
      [breakpoints.up('xl')]: {
        margin: spacing(0, 2, 8),
      },
    },
    withSubtitle: {
      margin: spacing(0, 2, 2.5),
      [breakpoints.up('sm')]: {
        margin: spacing(0, 2, 2.5),
      },
      [breakpoints.up('xl')]: {
        margin: spacing(0, 2, 2.5),
      },
    },
    default: {},
    contrast: {},
  }),
);

interface SectionTitleProps {
  title?: string;
  subtitle?: string;
  color?: 'default' | 'contrast';
}

const SectionTitle = ({
  title,
  subtitle,
  color = 'default',
}: SectionTitleProps) => {
  const { classes, cx } = useStyles();

  if (!title && !subtitle) return null;
  return (
    <>
      {title ? (
        <Typography
          variant="h2"
          className={cx(
            classes.text,
            subtitle && classes.withSubtitle,
            classes[color],
          )}
        >
          {title}
        </Typography>
      ) : null}
      {subtitle ? (
        <Typography
          variant="subtitle2"
          component="h3"
          className={cx(classes.text, classes[color])}
        >
          {subtitle}
        </Typography>
      ) : null}
    </>
  );
};

export default SectionTitle;
